import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import URL, { NIPIN_AUTHKEY } from '../../../constants/url';
import Navbar from '../../../components/comm/Navbar';
import Header from '../../../components/comm/Head';
import Modal from "../../../components/comm/Modal"
import imgChatbot from "../../../images/user/i_chatbot_01.svg"
import ToastPopup from '../../../components/comm/ToastPopup';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import style from './HomeCareMain.module.css';

import HomeTodo from './HomeTodo';
import MedicalGuide from './MedicalGuide';
import CustomHealth from './CustomHealth';

import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';

import DialBox from '../../../components/comm/DialBox';

import useAppVersionCheck from '../../../hook/useAppVersionCheck';
import AppNoticeBox from '../../../components/box/AppNoticeBox';
import UpdateNoticeBox from '../../../components/box/UpdateNoticeBox';

const HomeCare = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser"));
    //console.log(" ==========> HomeCareMain session : ", user);
    //console.log(" ==========> NIPIN_AUTHKEY : ", NIPIN_AUTHKEY);

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    // 기본 탭 값은 '1'
    // mountedTabs state 추가 (defaultTab 아래에)
    const defaultTab = searchParams.get('tab') || '1';
    const [value, setValue] = useState(defaultTab);
    const [mountedTabs, setMountedTabs] = useState(new Set([defaultTab]));

    // 토스트
    const [toast, setToast] = useState(false);
    const [pillFinishToast, setPillFinishToast] = useState(false);
    const [pillToastMessage, setPillToastMessage] = useState('');
    const [toastMessage, setToastMessage] = useState('');

    //모달창
    const [isOpen, setIsOpen] = useState(false);
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);


    const {
        needsUpdate,
        openStore,
        isLoaded,
        currentVersion,
        latestVersion,
        storeUrl
    } = useAppVersionCheck();
    const [showPopup, setShowPopup] = useState(false);

    // RN 푸시 라우팅 연동 로직                                      
    useEffect(() => {
        let handled = false;

        const handlePushRoute = (event) => {
            try {
                const data = typeof event.data === 'string' ?
                    JSON.parse(event.data) : event.data;
                if (data.type === 'PUSH_NAVIGATE' && data.route) {
                    if (window.ReactNativeWebView) {

                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            type: 'PUSH_NAVIGATE_ACK',
                            route: data.route
                        }));
                    }

                    if (handled) return;
                    handled = true;

                    navigate(data.route, {
                        state: data.payload,
                        // replace: true
                    });
                }
            } catch (err) { console.log('handlePushRoute:', err); }
        };

        window.addEventListener('message', handlePushRoute);
        document.addEventListener('message', handlePushRoute);

        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'WEB_READY_AUTH_OK'
            }));
        }

        return () => {
            window.removeEventListener('message', handlePushRoute);
            document.removeEventListener('message', handlePushRoute);
        };
    }, [navigate]);

    useEffect(() => {
        // console.log('currentVersion : ', currentVersion);
        // console.log('latestVersion : ', latestVersion);
        // console.log('needsUpdate : ', needsUpdate);
        // console.log('isLoaded : ', isLoaded);

        if (isLoaded && needsUpdate) {
            setShowPopup(true);
        }
    }, [isLoaded, needsUpdate, currentVersion, latestVersion]);

    useEffect(() => {
        const tabParam = searchParams.get('tab') || '1';
        if (tabParam !== value) {
            setValue(tabParam);

            setMountedTabs(prev => {
                const next = new Set(prev);
                next.add(tabParam);
                return next;
            });
        }
    }, [searchParams, value]);

    // 외부에서 state로 전달한 toast 처리
    useEffect(() => {
        if (location.state?.toastMessage) {
            setToastMessage(location.state.toastMessage);
            setToast(true);

            // state 초기화
            navigate(location.pathname + location.search, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, location.search, navigate]);

    useEffect(() => {
        const tabParam = searchParams.get('tab');
        if (tabParam && tabParam !== value) {
            setValue(tabParam);
        }
    }, [searchParams]);

    const handleNavigateToGuide = () => {
        setValue('2');
        setSearchParams({ tab: '2' });

        setMountedTabs(prev => {
            const next = new Set(prev);
            next.add('2');
            return next;
        });
    };

    // handleChange 수정
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSearchParams({ tab: newValue });

        setMountedTabs(prev => {
            const next = new Set(prev);
            next.add(newValue);
            return next;
        });

        // indicator 재계산
        requestAnimationFrame(() => {
            window.dispatchEvent(new Event('resize'));
        });

        if (newValue === '1') {
            setTimeout(() => {
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({
                        type: 'REQUEST_NOTIFICATIONS',
                        timestamp: Date.now(),
                        forceRefresh: true
                    }));
                }
            }, 100);
        }
    };


    // 마운트 시 한 번만 모달 오픈
    // useEffect(() => {
    //        const hideModal = sessionStorage.getItem('hideHomeCareModal');
    //     if (!hideModal) {
    //         setIsOpen(true); // 모달 보여줌
    //     }
    // }, []);

    useEffect(() => {
        const hideModal = sessionStorage.getItem('hideHomeCareModal');
        if (!hideModal) {
            const observer = setInterval(() => {
                const user = sessionStorage.getItem('loginUser');
                if (user) {
                    {/* 복약정보를 확인하여 셋팅 필요 */ }
                    //setIsOpen(true);
                    clearInterval(observer);
                }

            }, 200);
            return () => clearInterval(observer);
        }
    }, [location.key]);

    const handleCloseModal = () => {
        if (doNotShowAgain) {
            sessionStorage.setItem('hideHomeCareModal', 'true');
        }
        setIsOpen(false);
    };

    const handleCheckboxChange = (e) => {
        setDoNotShowAgain(e.target.checked);

        if (e.target.checked) {
            sessionStorage.setItem('hideHomeCareModal', 'true');
        } else {
            sessionStorage.removeItem('hideHomeCareModal');
        }
    };

    useEffect(() => {
        const toastType = sessionStorage.getItem('showToast');

        if (toastType === 'add') {
            setPillToastMessage('추가 완료!');
        } else if (toastType === 'modify') {
            setPillToastMessage('수정 완료!');
        }

        if (toastType) {
            sessionStorage.removeItem('showToast');
        }
    }, []);



    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }
    }, [isOpen]);

    useEffect(() => {
        if (window.ReactNativeWebView) {
            updateNotificationsToken();
        }
    }, []);

    /*
    푸시 알림 토큰 업데이트 (우리 자체 DB)
    */
    const updateNotificationsToken = async () => {
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const jToken = localStorage.getItem("jToken");

        const url = "/notifications/token";

        const reqBody = {
            pushTknVal: sessionStorage.getItem('pushToken'),
            usrInfoId: loginUser.usrInfoId,
        }

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        };

        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);

            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                console.log('[[[[[ 앱 내 푸시토큰 저장 완료, 만약 앱이 아니면 토큰이 없어짐 ]]]]]] : ' + sessionStorage.getItem('pushToken'));

            } else {

            }
        } catch (err) {
            console.error("updateNotificationsToken err", err);
            return false;
        }
    };

    return (

        <div>
            <Header menu="homecare" />

            {/* return 부분 - TabContext 유지, TabPanel 제거 */}
            <div className="container" data-posi='fixed'>
                <TabContext value={value}>
                    <div className='top-tab-head' data-posi='fixed'>
                        <TabList
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                            variant="scrollable"
                            scrollButtons={false}
                        >
                            <Tab label="오늘 할일" value="1" disableRipple />
                            <Tab label="재택 치료 가이드" value="2" disableRipple />
                            <Tab label="맞춤 질환 정보" value="3" disableRipple />
                        </TabList>
                    </div>

                    {/* TabPanel 대신 직접 display 토글 — TabContext 안에 있으므로 하위 TabList 정상 동작 */}
                    {mountedTabs.has('1') && (
                        <div style={{ display: value === '1' ? 'block' : 'none' }} role="tabpanel">
                            <HomeTodo onNavigateToGuide={handleNavigateToGuide} />
                        </div>
                    )}
                    {mountedTabs.has('2') && (
                        <div style={{ display: value === '2' ? 'block' : 'none' }} role="tabpanel">
                            <MedicalGuide />
                        </div>
                    )}
                    {mountedTabs.has('3') && (
                        <div style={{ display: value === '3' ? 'block' : 'none' }} role="tabpanel">
                            <CustomHealth />
                        </div>
                    )}
                </TabContext>
            </div>

            {/* 챗봇 메뉴 : 숨김 처리(2025.12.11) >> 2026.02.02. 다시 열어달라 요청 : 유호민 */}
            <DialBox />

            {/* 하단 메뉴 바   */}
            <Navbar />


            {showPopup && (
                <UpdateNoticeBox
                    onClose={() => setShowPopup(false)}
                    latestVersion={latestVersion}
                    storeUrl={storeUrl}
                />
            )}


            {/*    모달창    */}
            <Modal isOpen={isOpen} setIsOpen={setIsOpen}  >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className={style['chatbot-i-box']}>
                            <object data={imgChatbot} className='ani-float' aria-hidden='true'></object>
                            {/* <img src={imgChatbot} alt="chatbot" className="ani-float" /> */}
                        </div>
                        <div className='title-box'>
                            <p> 약 복용을 안한지 3일이 지났어요</p>
                        </div>
                        <div className='sub-box'>
                            <span>오늘부터 다시 차근차근 시작해볼까요? <br />
                                작은 습관이 건강을 지켜줍니다!</span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">

                        {/* 타입 1 */}
                        <div className='btn-layout' data-type='c'>
                            <div className="chkbox-custom" data-chkbox="basic">
                                <input type="checkbox" name="chkId" id="chkId" checked={doNotShowAgain} onChange={handleCheckboxChange} />
                                <label htmlFor="chkId">
                                    <div className={style['txt-box']}>
                                        <p>다시 보지 않기</p>
                                    </div>
                                </label>
                            </div>
                            <button className={style['txt-btn']} onClick={handleCloseModal}>
                                <span>닫기</span>
                            </button>
                        </div>


                        {/* 타입 2 */}
                        {/* <div className='btn-layout' data-type='b'>
                                        <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => setIsOpen(false)}>
                                            <span>챗봇에게 물어보기</span>
                                        </button>
                                        <button className="btn" data-btn-type="fill-gray" data-btn-size="lg" onClick={() => setIsOpen(false)}>
                                            <span>닫기</span>
                                        </button>
                                    </div> */}

                    </div>
                </div>
            </Modal>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}

            {pillToastMessage && (
                <ToastPopup
                    setToast={() => setPillToastMessage('')}
                    message={pillToastMessage}
                    position="center"
                    opacity="90"
                />
            )}


        </div>
    );
};

export default HomeCare;

